import React from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'Components/NoSSR';
import { connect } from 'react-redux';
import withPrivacyEye from 'Components/PrivacyEyeHOC';


const Header = props => {
  const {
    auth,
    bets,
    toggleBetSlip,
    privacy,
  } = props;

  const _renderCountInfo = bets.length
    ? <div className="betslip__header__count-info">
      <span>{ bets.length }</span> Maç
    </div>
    : null;

  return (
    <div className="betslip__header">
      <NoSSR>
        <div className="betslip__header__balance">
          { auth?.isAuthenticated && (
          <>
       <div className="betslip__header__balance__text">{ privacy?.balanceName }
         <div className={ !privacy?.isEyeOpen ? 'betslip__header__balance__text__eye' : 'betslip__header__balance__text__eye-close' }>
           <i onClick={ ()=>privacy?.toggleEye() } className={ `${privacy?.icon} bly-white` } />
         </div>
       </div>

        <div className="betslip__header__balance__value">
          { privacy.isEyeOpen ? `${privacy?.balance} ₺` : privacy?.balance }
        </div>
          </>
          ) }
        </div>
      </NoSSR>

      { _renderCountInfo }

      <div className="betslip__header__close-button" onClick={ toggleBetSlip }>
        <div className="betslip__header__close-button__text">Kapat</div>

        <i
          className="bly bly-caret-down bly-size10 betslip__header__close-button__arrow"
        />
      </div>
    </div>
  );
};

Header.propTypes = {
  toggleBetSlip: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  auth: PropTypes.object,
  bets: PropTypes.array,
  privacy: PropTypes.object,
};

const mapStateToProps = state => ({
});

export default connect(
  mapStateToProps,
)(withPrivacyEye(Header));
